import api from './api';

const featureService = {
  // Get all features for a project
  getProjectFeatures: async (projectId) => {
    try {
      const response = await api.get(`/features/projects/${projectId}`);
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch features';
    }
  },

  // Create a new feature
  createFeature: async (projectId, featureData) => {
    try {
      const response = await api.post(`/features/projects/${projectId}`, featureData);
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to create feature';
    }
  },

  // Update a feature
  updateFeature: async (featureId, featureData) => {
    try {
      const response = await api.put(`/features/${featureId}`, featureData);
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to update feature';
    }
  },

  // Delete a feature
  deleteFeature: async (featureId) => {
    try {
      await api.delete(`/features/${featureId}`);
      return true;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to delete feature';
    }
  },

  // Get user stories for a feature
  getFeatureUserStories: async (featureId) => {
    try {
      const response = await api.get(`/features/${featureId}/stories`);
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch user stories';
    }
  },

  // Get all user stories for a project
  getProjectUserStories: async (projectId) => {
    try {
      const response = await api.get(`/features/projects/${projectId}/stories`);
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch project user stories';
    }
  },
  
  // Batch upload user stories for a project
  batchUploadUserStories: async (projectId, storiesData) => {
    try {
      const response = await api.post(`/features/projects/${projectId}/stories/batch`, storiesData);
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to batch upload user stories';
    }
  },

  // Create a new user story
  createUserStory: async (featureId, storyData) => {
    try {
      const response = await api.post(`/features/${featureId}/stories`, storyData);
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to create user story';
    }
  },

  // Update a user story
  updateUserStory: async (storyId, storyData) => {
    try {
      const response = await api.put(`/features/stories/${storyId}`, storyData);
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to update user story';
    }
  },

  // Delete a user story
  deleteUserStory: async (storyId) => {
    try {
      await api.delete(`/features/stories/${storyId}`);
      return true;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to delete user story';
    }
  }
};

export default featureService;